/**
 * We create one common Icon component that will be used to display the social icons.
 * Currently we have the following social icons:
 * - Whatsapp
 * - SMS
 * - Email
 * Each icon will have their own background color and icon color.
 * We need this component so that we have consistent icons across the app.
 * We will just pass the className for sizes and other common props only
 */

import { cn } from '@/lib/utils';
import { FaWhatsapp } from 'react-icons/fa';
import { FaRegMessage } from 'react-icons/fa6';
import { MdOutlineEmail } from 'react-icons/md';

export const SOCIAL_ICONS = {
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  EMAIL: 'email',
} as const;

export type TSocialIconType = (typeof SOCIAL_ICONS)[keyof typeof SOCIAL_ICONS];

type TSocialIcons = {
  type: TSocialIconType;
  className?: string;
  iconClassName?: string;
};

const IconClassName: Record<TSocialIconType, string> = {
  [SOCIAL_ICONS.WHATSAPP]: 'bg-green-100',
  [SOCIAL_ICONS.SMS]: 'bg-sky-100',
  [SOCIAL_ICONS.EMAIL]: 'bg-emerald-100',
};

const SocialIconMap: Record<TSocialIconType, React.ElementType> = {
  whatsapp: FaWhatsapp,
  sms: FaRegMessage,
  email: MdOutlineEmail,
};

export const SocialIcons = ({ type, className, iconClassName }: TSocialIcons) => {
  const Icon = SocialIconMap[type];
  return (
    <span className={cn('rounded-full p-2', IconClassName[type], className)}>
      <Icon className={cn('size-4', iconClassName)} />
    </span>
  );
};
